<template>
  <strong class="name">
    Bi<span class="brand-accent">ll</span>ium<span class="brand-accent"
      >KG</span
    >
  </strong>
</template>

<script>
export default {
  name: 'NameComponent',
}
</script>

<style scoped>
.name {
  font-family: 'Varela Round', sans-serif;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 1px;
  display: inline-flex;
  align-items: center;
}

.brand-accent {
  /* Сочный неоново-синий (электрик) цвет */
  color: #00d2ff;

  /* Мягкая синяя неоновая подсветка */
  text-shadow: 0 0 12px rgba(0, 210, 255, 0.6);
  transition: all 0.3s ease;
}

.name:hover .brand-accent {
  /* Чуть более яркий оттенок при наведении */
  color: #00e5ff;
  /* Усиливаем свечение при наведении */
  text-shadow: 0 0 18px rgba(0, 229, 255, 0.9);
}
</style>
